import React from 'react';
import styled from 'styled-components';

import { usePicture } from '../../../../hooks';
import { MOBILE, TABLET, DESKTOP } from '../../../../helpers/styles/media';

const Benefit = () => {
  return (
    <Wrapper>
      <Image>
        {usePicture([
          'benefit-mob.png',
          'benefit-tab.png',
          'benefit-desk.png',
        ])}
      </Image>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  position: relative;
  max-width: 1920px;
  background-color: #000;

  @media ${DESKTOP} {
    height: 139px;
    margin: 70px auto;
  }

  @media ${TABLET} {
    height: 87.65px;
    margin: 40px auto 66px;
  }

  @media ${MOBILE} {
    height: 77px;
    margin: 61px auto 31px;
  }
`;

const Image = styled.div`
  position: absolute;

  @media ${DESKTOP} {
    top: -30px;
    left: calc(50% - 826px / 2);
  }

  @media ${TABLET} {
    top: -20px;
    left: calc(50% - 522px / 2);
  }

  @media ${MOBILE} {
    top: -32px;
    left: calc(50% - 350px / 2);
  }
`;

export default Benefit;
